'use client';

import { NavDock } from '@bomdisoft/components';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { homeText, navOrders, produceText } from '@pieleaf/translations';
import { useParams } from 'next/navigation';

export const MainNavDock = () => {
  const params = useParams();
  const langPrefix = typeof params.lang === 'string' ? params.lang : 'en';
  const language = getLanguageFromLocale(langPrefix);

  const items = [
    { exact: true, href: `/${langPrefix}`, label: homeText[language], matchPaths: [`/${langPrefix}`], testId: 'nav-link-home' },
    { href: `/${langPrefix}/produce`, label: produceText[language], matchPaths: [`/${langPrefix}/produce`], testId: 'nav-link-produce' },
    { href: `/${langPrefix}/orders`, label: navOrders[language], matchPaths: [`/${langPrefix}/orders`], testId: 'nav-link-orders' },
  ];

  return <NavDock items={items} testId='main-nav-dock' />;
};
